module.exports = __webpack_public_path__ + "media/images/payments/mastercard-8e39a2a1a761155dab4be2bfbf18d5a2.svg";